import React from "react";
import { useAuth } from "../../auth/AuthContext";
import { useLocation } from "react-router-dom";
import AccessDeniedPage from "../common/AccessDeniedPage";

const AdminRoute = ({ children, allowedUserTypes }) => {
  const { userType } = useAuth();
  const location = useLocation();

  // Check if the user has at least one of the allowed roles
  const hasAccess = userType && allowedUserTypes.some((type) => userType.includes(type));

  return hasAccess ? children : <AccessDeniedPage redirectPath={location.pathname} />;
};

export default AdminRoute;
